import { Result } from "antd";

const Page404 = ({ history }) => {
  return <Result className="pt-70 pb-70" status="warning" title="404" subTitle="페이지를 찾을 수 없습니다." />;
};

export default Page404;
